import { useLingui } from '@lingui/react';

import { Flex, Paragraph } from '@rover/kibble/core';
import type { EnhancedPersonSitterProfileService } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfileService';

import { getAcceptingNewCustomersLabel } from './utils';

type Props = {
  service: EnhancedPersonSitterProfileService;
};

const AcceptingNewCustomersLabel = ({ service }: Props): JSX.Element | null => {
  const { i18n } = useLingui();
  const label = getAcceptingNewCustomersLabel(service);

  if (!label) {
    return null;
  }

  const { text, icon: Icon } = label;

  return (
    <Flex justifyContent="space-between" alignItems="center" pt="4x">
      <Paragraph size="100" marginBottom="0x">
        {i18n._(text)}
      </Paragraph>
      <Icon width={16} height={16} aria-hidden />
    </Flex>
  );
};

export default AcceptingNewCustomersLabel;
